import {FormFieldT} from '@/lib/types/form.types';
import {ProductCategoryT, productInsertT} from '@/lib/types/product.types';

import {cannabinoidUnits, productStrains} from '@/lib/constants';

export const getCreateProductFields = (
  categoryOptions: ProductCategoryT[],
  subCategoryOptions: ProductCategoryT[]
): FormFieldT<productInsertT>[] => {
  return [
    {name: 'product_name', label: 'Product Name', type: 'text', placeholder: 'Product Name', required: true},
    {name: 'product_display_name', label: 'Display Name', type: 'text', placeholder: 'Display Name', required: true},
    {
      name: 'product_strain',
      label: 'Strain',
      type: 'select',
      placeholder: 'Strain',
      required: true,
      selectOptions: productStrains,
    },
    {name: 'product_cbd_content', label: 'CBD Content', type: 'number', placeholder: 'CBD Content', required: true},
    {
      name: 'product_cbd_content_unit',
      label: 'CBD Content Unit',
      type: 'select',
      placeholder: 'CBD Content Unit',
      required: true,
      selectOptions: cannabinoidUnits,
    },
    {name: 'product_thc_content', label: 'THC Content', type: 'number', placeholder: 'THC Content', required: true},
    {
      name: 'product_thc_content_unit',
      label: 'THC Content Unit',
      type: 'select',
      placeholder: 'THC Content Unit',
      required: true,
      selectOptions: cannabinoidUnits,
    },
    {name: 'product_flavor', label: 'Flavor', type: 'text', placeholder: 'Flavor', required: true},
    {
      name: 'product_wholesale_price',
      label: 'Wholesale Price',
      type: 'number',
      placeholder: 'Wholesale Price',
      required: true,
    },
    {name: 'product_med_price', label: 'Med Price', type: 'number', placeholder: 'Med Price', required: true},
    {name: 'product_rec_price', label: 'Rec Price', type: 'number', placeholder: 'Rec Price', required: true},
    {
      name: 'product_category',
      label: 'Select Category',
      type: 'select',
      placeholder: 'Category Name',
      required: true,
      selectOptions: categoryOptions,
    },
    {
      name: 'product_subcategory',
      label: 'Select Subcategory',
      type: 'select',
      placeholder: 'Subcategory Name',
      required: true,
      selectOptions: subCategoryOptions,
    },
  ];
};
